import { render, staticRenderFns } from "./TicketStats.vue?vue&type=template&id=d4831df8"
import script from "./TicketStats.vue?vue&type=script&lang=js"
export * from "./TicketStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports